"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _FeatureCard = require("./FeatureCard.style");
var _styledComponents = require("styled-components");
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var FeatureCard = function FeatureCard(_ref) {
  var children = _ref.children,
    column = _ref.column,
    image = _ref.image,
    imageAltText = _ref.imageAltText,
    imageLink = _ref.imageLink,
    imageMobile = _ref.imageMobile,
    imageTarget = _ref.imageTarget,
    imageOnly = _ref.imageOnly,
    reverse = _ref.reverse,
    theme = _ref.theme,
    youtubeVideoId = _ref.youtubeVideoId;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isImageLoading = _useState2[0],
    setIsImageLoading = _useState2[1];
  return /*#__PURE__*/_react.default.createElement(_FeatureCard.Wrapper, {
    column: column,
    reverse: reverse,
    "data-key": "max-featured-card"
  }, image && !youtubeVideoId && /*#__PURE__*/_react.default.createElement(_FeatureCard.ImageWrapper, {
    as: imageLink ? 'a' : 'div',
    column: column,
    href: imageLink || null,
    isImageLoading: isImageLoading,
    target: imageTarget || null
  }, /*#__PURE__*/_react.default.createElement(_FeatureCard.Picture, {
    "data-key": "max-feature-card__image",
    column: column
  }, /*#__PURE__*/_react.default.createElement("source", {
    srcSet: image || imageMobile,
    media: "(min-width: ".concat(theme.breakpoints.md, ")")
  }), /*#__PURE__*/_react.default.createElement("img", {
    alt: imageAltText || '',
    onLoad: function onLoad() {
      return setIsImageLoading(false);
    },
    role: imageAltText ? 'img' : 'presentation',
    src: imageMobile || image
  }))), youtubeVideoId && /*#__PURE__*/_react.default.createElement(_FeatureCard.VideoWrapper, {
    column: column,
    isImageLoading: isImageLoading
  }, /*#__PURE__*/_react.default.createElement(_FeatureCard.IFrame, {
    onLoad: function onLoad() {
      return setIsImageLoading(false);
    },
    src: "https://www.youtube.com/embed/".concat(youtubeVideoId, "?rel=0"),
    frameBorder: "0",
    allowFullScreen: true,
    "data-key": "max-feature-card__video",
    loading: "lazy",
    title: "Youtube Video"
  })), !imageOnly && /*#__PURE__*/_react.default.createElement(_FeatureCard.Text, {
    "data-key": "max-feature-card__content",
    column: column
  }, children));
};
FeatureCard.defaultProps = {
  reverse: false,
  column: false
};
var _default = (0, _styledComponents.withTheme)(FeatureCard);
exports.default = _default;